import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import {
  formatDateStringdot,
  handleError,
} from "../CommonJquery/CommonJquery.js";

import Loader from "./Loader";

const ViewAgreeMentForm = forwardRef((props, ref) => {
  console.log("ViewAgreementForm component initialized");
  const [loading, setLoading] = useState(false);
  const data = props.downloadForm2;
  const SignImg = props.SignImg;
  const DringImg = props.DringImg;

  console.log("ViewAgreementForm props", data);

  const handleDownloadPDF2 = () => {
    if (!data || Object.keys(data).length === 0) {
      return;
    }

    const AgreePart1 = document.getElementById("pdf-agreement-part-1");
    const AgreePart2 = document.getElementById("pdf-agreement-part-2");
    const AgreePart3 = document.getElementById("pdf-agreement-part-3");
    const AgreePart4 = document.getElementById("pdf-agreement-part-4");
    const AgreePart5 = document.getElementById("pdf-agreement-part-5");
    const AgreePart6 = document.getElementById("pdf-agreement-part-6");
    const AgreePart7 = document.getElementById("pdf-agreement-part-7");
    const AgreePart8 = document.getElementById("pdf-agreement-part-8");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const renderPart = (element, isFirstPart) => {
      return html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        allowTaint: true,
        letterRendering: true,
        imageTimeout: 0,
        backgroundColor: "#FFFFFF",
        windowWidth: 794, // A4 width in pixels at 96 DPI
        windowHeight: 1123, // A4 height in pixels at 96 DPI
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png", 0.95);

        // A4 dimensions in mm
        const pdfWidth = 210;
        const pdfHeight = 297;

        // Calculate image dimensions to fit within page
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        if (!isFirstPart) {
          pdf.addPage();
        }

        // If content is taller than page, fit it to page height
        if (imgHeight > pdfHeight) {
          const ratio = pdfHeight / imgHeight;
          const scaledWidth = imgWidth * ratio;
          const scaledHeight = pdfHeight;
          const xOffset = (pdfWidth - scaledWidth) / 2;
          pdf.addImage(imgData, "PNG", xOffset, 0, scaledWidth, scaledHeight);
        } else {
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        }
      });
    };

    renderPart(AgreePart1, true)
      .then(() => renderPart(AgreePart2, false))
      .then(() => renderPart(AgreePart3, false))
      .then(() => renderPart(AgreePart4, false))
      .then(() => renderPart(AgreePart5, false))
      .then(() => renderPart(AgreePart6, false))
      .then(() => renderPart(AgreePart7, false))
      .then(() => renderPart(AgreePart8, false))
      .then(() => {
        pdf.setProperties({
          title: "Agreement",
          subject: "Car Rental Agreement",
          creator: "Rapid Car Leasing",
          author: "System",
        });

        const fileName = `Agreement-${data?.first_name || "New"}-${
          data?.last_name || ""
        }-${data?.car_data?.car_name || ""}-${data?.from_date || ""}-to.pdf`;
        pdf.save(fileName.replace(/\s+/g, "-"));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        setLoading(false);
      });
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF2: () => {
      if (!data || Object.keys(data).length === 0) {
        console.warn("Data not ready yet.");
        return;
      }
      handleDownloadPDF2();
    },
  }));

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setLoading(true);
      handleDownloadPDF2();
    }
  }, [data]);

  return (
    <div className="pdf-agreement-wrapper">
      <button
        onClick={handleDownloadPDF2}
        disabled={!data || Object.keys(data).length === 0}
        className="pdf-agreement-download-btn"
        style={{
          padding: "10px 20px",
          backgroundColor: "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Download Agreement PDF
      </button>

      {loading && <Loader />}

      <div
        id="pdf-agreement-content"
        className="pdf-agreement-content"
        style={{ position: "absolute", left: "-9999px" }}
      >
        {/* ==================== PAGE 1 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-1"
          id="pdf-agreement-part-1"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          {/* Logo and Header */}
          <div
            className="pdf-agreement-header"
            style={{ marginBottom: "15px" }}
          >
            <div
              className="pdf-agreement-logo"
              style={{
                fontSize: "24pt",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
              }}
            >
              <span style={{ color: "#000" }}>Rapid</span>
              <span style={{ color: "#4CAF50" }}>Car</span>
            </div>
            <div
              className="pdf-agreement-logo-subtitle"
              style={{
                fontSize: "14pt",
                color: "#4CAF50",
                fontWeight: "500",
              }}
            >
              LEASING
            </div>
          </div>

          <h1
            className="pdf-agreement-title"
            style={{
              fontSize: "18pt",
              fontWeight: "bold",
              textAlign: "right",
              marginBottom: "15px",
              color: "#333",
            }}
          >
            Agreement for Car Leasing
          </h1>

          {/* Personal Information */}
          <table
            className="pdf-agreement-info-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "15px",
            }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                    width: "40%",
                  }}
                >
                  Name
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingBottom: "10px" }}
                >
                  {data?.first_name || ""} {data?.last_name || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  Date of Birth
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingBottom: "10px" }}
                >
                  {formatDateStringdot(data?.dob_date || "")}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  Driver's License Number & State
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingBottom: "10px" }}
                >
                  {data?.driving_licence || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  Phone Number
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingBottom: "10px" }}
                >
                  {data?.mobile_no || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  Email
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingBottom: "10px" }}
                >
                  {data?.email || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  Present Address
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingBottom: "10px" }}
                >
                  {data?.present_map_address || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  How long you need the car
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    paddingBottom: "10px",
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.long_need_car || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "10px",
                  }}
                >
                  Approved and ready to work for (Chose one or more):
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    paddingBottom: "10px",
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.Approved_readr_work || ""}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Picture of DL */}
          <div
            className="pdf-agreement-dl-section"
            style={{ marginTop: "20px" }}
          >
            <div
              className="pdf-agreement-dl-label"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Picture of DL
            </div>
            {data?.driving_licence_image && (
              <img
                className="pdf-agreement-dl-image"
                src={DringImg + data?.driving_licence_image}
                alt="Driver License"
                style={{
                  maxWidth: "100%",
                  maxHeight: "220px",
                  border: "1px solid #ddd",
                }}
              />
            )}
          </div>
        </div>

        {/* ==================== PAGE 2 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-2"
          id="pdf-agreement-part-2"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          {/* Car Information Header */}
          <div
            className="pdf-agreement-car-info"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "10px 15px",
              marginBottom: "15px",
              fontSize: "10pt",
            }}
          >
            ( {data?.car_data?.car_tagline || ""} )
            {data?.car_data?.car_name || ""} / VIN#:
            {data?.car_data?.vin || ""} / Make:
            {data?.car_data?.make_year || ""} / Model:
            {data?.car_data?.model_name || ""}
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Name
                </td>
                <td className="pdf-agreement-value">
                  {data?.first_name || ""} {data?.last_name || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Driver's License Number & State
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingTop: "10px" }}
                >
                  {data?.driving_licence || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Start Date
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingTop: "10px" }}
                >
                  {data?.from_date || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            Terms and Conditions for Agreement to Rent Vehicle
          </h2>

          <div
            className="pdf-agreement-renter-name"
            style={{ marginBottom: "10px" }}
          >
            {data?.first_name || ""} {data?.last_name || ""}
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            1. The vehicle may be driven during the rental term only by the
            persons named in this Document.
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            2. The renter shall pay the rent rental of the vehicle the sum or
            sums specified in this Document; and authorizes the owner to charge
            all amounts payable to the renter's account. The renter's account
            means a nominated debit card, credit card, or pre-arranged charge
            account.
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            3. In addition to the payment specified in clause 2 above, the
            renter acknowledges that they shall be liable for the rental term
            any applicable additional charges payable at the end of the term.
            These include, but are not limited to:
          </div>

          <div
            className="pdf-agreement-sublist"
            style={{ marginLeft: "20px", marginBottom: "15px" }}
          >
            <div
              className="pdf-agreement-text-block"
              style={{ marginBottom: "10px", textAlign: "justify" }}
            >
              (a.) Charges for gas or other fuel used; Road user charges / Toll
              Charges; Charges for late return of the vehicle etc;
            </div>
            <div
              className="pdf-agreement-text-block"
              style={{ marginBottom: "10px", textAlign: "justify" }}
            >
              (b.) Charges for cleaning the vehicle's interior, if the vehicle
              is returned in a dirty condition that requires extra cleaning or
              deodorizing. This includes, but is not limited to, spillage of
              fluids, food, vomit, other stains, and unpleasant odors including
              cigarette smoke.
            </div>
            <div
              className="pdf-agreement-text-block"
              style={{ marginBottom: "10px", textAlign: "justify" }}
            >
              (c.) Liability of Traffic and/or parking Tickets / offence
              infringement fees.
            </div>
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginTop: "20px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Agree Point 1 to 3(c)?
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  Yes, Agree Point 1 to 3(c)
                </td>
              </tr>
            </tbody>
          </table>

          <div
            className="pdf-agreement-signature-section"
            style={{ marginTop: "25px" }}
          >
            <div
              className="pdf-agreement-signature-label"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Signature
            </div>
            {data?.signature_image && (
              <img
                className="pdf-agreement-signature-image"
                src={SignImg + data?.signature_image}
                alt="Signature"
                style={{ maxWidth: "200px", maxHeight: "80px" }}
              />
            )}
          </div>

          <div
            className="pdf-agreement-name-section"
            style={{ marginTop: "20px" }}
          >
            <div
              className="pdf-agreement-name-label"
              style={{ fontWeight: "bold" }}
            >
              Name
            </div>
            <div className="pdf-agreement-name-value">
              {data?.first_name || ""} {data?.last_name || ""}
            </div>
          </div>
        </div>

        {/* ==================== PAGE 3 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-3"
          id="pdf-agreement-part-3"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Terms and Conditions for Agreement to Rent Vehicle
          </h2>
          <div
            className="pdf-agreement-continue-text"
            style={{ fontSize: "12pt", marginBottom: "15px" }}
          >
            Continue
          </div>

          {/* Car Information Header */}
          <div
            className="pdf-agreement-car-info"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "10px 15px",
              marginBottom: "15px",
              fontSize: "10pt",
            }}
          >
            ( {data?.car_data?.car_tagline || ""} )
            {data?.car_data?.car_name || ""} / VIN#:
            {data?.car_data?.vin || ""} / Make:
            {data?.car_data?.make_year || ""} / Model:
            {data?.car_data?.model || ""}
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Name
                </td>
                <td className="pdf-agreement-value">
                  {data?.first_name || ""} {data?.last_name || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Driver's License Number & State
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingTop: "10px" }}
                >
                  {data?.driving_licence || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Start Date
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingTop: "10px" }}
                >
                  {data?.from_date || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            className="pdf-agreement-renter-name"
            style={{ marginBottom: "10px" }}
          >
            {data?.first_name || ""} {data?.last_name || ""}
          </div>

          <div
            className="pdf-agreement-text-bold"
            style={{ fontWeight: "bold", marginBottom: "10px" }}
          >
            4. The renter shall NOT:
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (a.) Sublet or rental the vehicle to any other person.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (b.) Allow the vehicle to be used outside his/her authority.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (c.) Operate the vehicle or allow it to be operated in circumstances
            that constitute an offence against any of Sections 56, 57 or 58 of
            the Act (which relates to driving under the influence of alcohol or
            drugs).
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (d.) Operate the vehicle or allow it to be operated in any race,
            speed test, reliability trial, rally, or contest, or operated on any
            race or rally circuit or in any event as a pacemaker or testing in
            preparation for any of them.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (e.) Operate the vehicle, or allow it to be operated, in breach of
            the Act, the Land Transport (Road User) Rule 2004, or any other Act,
            regulations, rules or bylaws relating to road traffic.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (f.) Operate the vehicle or allow it to be operated for the
            transport of more passengers or goods than the maximum specified in
            the certificate of loading and/or road user charge certificate,
            whichever is the lesser, for the vehicle.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (g.) Drive or allow the vehicle to be driven on any roads excluded
            in clause 22(q) of these terms and conditions, or on any beach,
            driveway, or surface likely to damage the vehicle.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (h.) Allow the vehicle to be driven by any person who is not named
            or described in the Rental Document as a person permitted to drive
            the vehicle.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (i.) Operate the vehicle or allow it to be operated to propel or tow
            any other vehicle.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px", textAlign: "justify" }}
          >
            (j.) Operate or allow the vehicle to be used in involvement with any
            illegal activity.
          </div>
          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            (k.) Do Smoking or do any illegal drugs in the vehicle.
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            5. RETURN OF VEHICLE: The renter shall, at or before the expiry of
            the term of rental, deliver the vehicle to the agreed rental
            location described in the Rental Document or obtain the owner's
            consent to the continuation of the rental (in which case the renter
            shall pay additional rental charges for the extended term of
            rental). If the renter does not comply with this clause, and does
            not immediately return the vehicle, the owner may report the vehicle
            as stolen to the Police and the renter must compensate the owner for
            either the full cost of the vehicle, or all additional costs and
            losses incurred up to the time that the vehicle is recovered by the
            owner.
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginTop: "20px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Agree Point 4 (a) to (k) & 5?
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  Yes, Agree Point 4 (a) to (k) & 5
                </td>
              </tr>
            </tbody>
          </table>

          <div
            className="pdf-agreement-signature-section"
            style={{ marginTop: "25px" }}
          >
            <table
              className="pdf-agreement-signature-table"
              style={{ width: "100%" }}
            >
              <tbody>
                <tr>
                  <td
                    className="pdf-agreement-signature-label"
                    style={{ fontWeight: "bold", width: "20%" }}
                  >
                    Signature
                  </td>
                  <td
                    className="pdf-agreement-name-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Name
                  </td>
                </tr>
                <tr>
                  <td
                    className="pdf-agreement-signature-cell"
                    style={{ paddingTop: "10px" }}
                  >
                    {data?.signature_image && (
                      <img
                        className="pdf-agreement-signature-image"
                        src={SignImg + data?.signature_image}
                        alt="Signature"
                        style={{ maxWidth: "150px", maxHeight: "60px" }}
                      />
                    )}
                  </td>
                  <td
                    className="pdf-agreement-name-value"
                    style={{ paddingTop: "10px" }}
                  >
                    {data?.first_name || ""} {data?.last_name || ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ==================== PAGE 4 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-4"
          id="pdf-agreement-part-4"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Terms and Conditions for Agreement to Rent Vehicle
          </h2>
          <div
            className="pdf-agreement-continue-text"
            style={{ fontSize: "12pt", marginBottom: "15px" }}
          >
            Continue
          </div>

          {/* Car Information */}
          <div
            className="pdf-agreement-car-info"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "10px 15px",
              marginBottom: "15px",
              fontSize: "10pt",
            }}
          >
            ( {data?.car_data?.car_tagline || ""} )
            {data?.car_data?.car_name || ""} / VIN#:
            {data?.car_data?.vin || ""} / Make:
            {data?.car_data?.make_year || ""} / Model:
            {data?.car_data?.model || ""}
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Name
                </td>
                <td className="pdf-agreement-value">
                  {data?.first_name || ""} {data?.last_name || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Driver's License Number & State
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingTop: "10px" }}
                >
                  {data?.driving_licence || ""}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Start Date
                </td>
                <td
                  className="pdf-agreement-value"
                  style={{ paddingTop: "10px" }}
                >
                  {data?.from_date || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <h3
            className="pdf-agreement-subsection-title"
            style={{
              fontSize: "12pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            6. READ AND ACCEPT FOLLOWING CONDITIONS OF RENTAL AGREEMENT:
          </h3>

          <ul
            className="pdf-agreement-list"
            style={{ marginLeft: "20px", marginBottom: "15px" }}
          >
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              OWNER requires that all vehicles to be brought bi-weekly for
              vehicle servicing.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              Any issues with the vehicle must be immediately reported.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              The owner has the right to terminate the rental and take immediate
              possession of the vehicle, if the renter fails to comply with any
              of the terms of the Rental Agreement or if the vehicle is damaged.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              Key damage / loss charge is $250
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              Repossession Charge is $250.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              Late fee is $10 Per day.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              Car will be picked up in case of non-payment for extending lease
              period.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              If there is any payment is balance, recovery action will be taken
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              Deposit if any will be forfeited and will be treated as car
              recovery fees.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              I understand that any payment made is not refundable.
            </li>
          </ul>

          <h3
            className="pdf-agreement-subsection-title"
            style={{
              fontSize: "12pt",
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            Continue
          </h3>

          <ul
            className="pdf-agreement-list"
            style={{ marginLeft: "20px", marginBottom: "15px" }}
          >
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              7. Damage to the vehicle: You will be personally responsible for
              any damage to the car.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              8. DO NOT Leave car keys in the car and turnoff the car when you
              leave the car.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              9. If car is Stolen / lost due to negligence, Renter will be
              responsible to pay the cost of car to the owner.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              10. In any event, the car will be released only to owner's
              authorize person / towing Company
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "8px" }}
            >
              11. Deductibles: $2500 per incident will be driver's
              responsibility. Rideshare platforms deductibles may be $2500 per
              incident.
            </li>
          </ul>

          <div
            className="pdf-agreement-text-bold"
            style={{
              marginTop: "20px",
              marginBottom: "15px",
              fontWeight: "bold",
            }}
          >
            Owner Responsibility: Vehicle Insurance & Maintenance.
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "10px" }}
          >
            OWNER, owner's Management, and its employees are NOT responsible
            for:
          </div>

          <div
            className="pdf-agreement-sublist"
            style={{ marginLeft: "20px", marginBottom: "15px" }}
          >
            <div
              className="pdf-agreement-text-block"
              style={{ marginBottom: "8px" }}
            >
              (a.) Any fault of the vehicle, any accidents, incident, unknown
              issues, natural cause, including any injury / death.
            </div>
            <div
              className="pdf-agreement-text-block"
              style={{ marginBottom: "8px" }}
            >
              (b.) Anything not covered by insurance, things left in the car
              after you drop-off or we have repossessed the car. Any driving/
              speeding/ parking tickets.
            </div>
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginTop: "20px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Last 4 of SSN
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.last_digit_ssn || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            className="pdf-agreement-signature-section"
            style={{ marginTop: "25px" }}
          >
            <div
              className="pdf-agreement-signature-label"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Signature
            </div>
            {data?.signature_image && (
              <img
                className="pdf-agreement-signature-image"
                src={SignImg + data?.signature_image}
                alt="Signature"
                style={{ maxWidth: "200px", maxHeight: "80px" }}
              />
            )}
          </div>

          <div
            className="pdf-agreement-name-section"
            style={{ marginTop: "20px" }}
          >
            <div
              className="pdf-agreement-name-label"
              style={{ fontWeight: "bold" }}
            >
              Name
            </div>
            <div className="pdf-agreement-name-value">
              {data?.first_name || ""} {data?.last_name || ""}
            </div>
          </div>
        </div>

        {/* ==================== PAGE 5 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-5"
          id="pdf-agreement-part-5"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "16pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Agreement for Car Leasing
          </h2>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  DL Expiration Date
                </td>
                <td className="pdf-agreement-value">
                  {formatDateStringdot(data?.driving_expiration_date || "")}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", paddingTop: "10px" }}
                >
                  Using car for (Chose one or more):
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    paddingTop: "10px",
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.using_car_for || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <h3
            className="pdf-agreement-subsection-title"
            style={{
              fontSize: "12pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Emergency Contacts
          </h3>

          <table
            className="pdf-agreement-emergency-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "15px",
            }}
          >
            <thead>
              <tr className="pdf-agreement-table-header">
                <th
                  className="pdf-agreement-table-th"
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "left",
                  }}
                ></th>
                <th
                  className="pdf-agreement-table-th"
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "left",
                  }}
                >
                  Name
                </th>
                <th
                  className="pdf-agreement-table-th"
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "left",
                  }}
                >
                  Relation
                </th>
                <th
                  className="pdf-agreement-table-th"
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "left",
                  }}
                >
                  Phone Number
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="pdf-agreement-table-row">
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  1nd
                </td>
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  {data?.emergency_contacts_name || ""}
                </td>
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  {data?.emergency_contacts_relation || ""}
                </td>
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  {data?.emergency_contacts || ""}
                </td>
              </tr>
              <tr className="pdf-agreement-table-row">
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  2nd
                </td>
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  {data?.emergency_contacts_name1 || ""}
                </td>
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  {data?.emergency_contacts_relation1 || ""}
                </td>
                <td
                  className="pdf-agreement-table-td"
                  style={{ border: "1px solid #ddd", padding: "8px" }}
                >
                  {data?.emergency_contacts1 || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Terms and Conditions for Agreement to Rent Vehicle
          </h2>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Today's Date
                </td>
                <td className="pdf-agreement-value">
                  {formatDateStringdot(data?.entry_date || "")}
                </td>
              </tr>
            </tbody>
          </table>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            FOR OFFICE USE ONLY
          </h2>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    width: "40%",
                    paddingBottom: "10px",
                  }}
                >
                  Car Owner Company
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.company_name || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Agreement for Tolls and Tickets for Rental Vehicle
          </h2>

          <div
            className="pdf-agreement-office-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>OWNER:</strong> {data?.company_name || ""}
          </div>
          <div
            className="pdf-agreement-office-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>RENTER:</strong> {data?.first_name || ""}{" "}
            {data?.last_name || ""}
          </div>
          <div
            className="pdf-agreement-office-info"
            style={{ marginBottom: "15px" }}
          >
            <strong>CAR INFO:</strong>( {data?.car_data?.car_tagline || ""} )
            {data?.car_data?.car_name || ""} / VIN#:
            {data?.car_data?.vin || ""} / Make:
            {data?.car_data?.make_year || ""} / Model:
            {data?.car_data?.model || ""}
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            I {data?.first_name || ""} {data?.last_name || ""}, will be liable
            and pay for any Tolls / Tickets come on the above rental car from
            date {formatDateStringdot(data?.from_date || "")} to
            ___________________.
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            I acknowledge that I am also liable to pay any all fines, penalties,
            traffic and/or parking violations, tolls fees, court costs, towing
            and impound charges, and other expenses relating to the Vehicle
            assessed for the above period.
          </div>

          <div
            className="pdf-agreement-license-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>My Driver License#</strong> {data?.driving_licence || ""}
          </div>
          <div
            className="pdf-agreement-address-label"
            style={{ marginBottom: "5px" }}
          >
            <strong>Present Residential Address:</strong>
          </div>
          <div
            className="pdf-agreement-address-details"
            style={{ marginLeft: "20px", marginBottom: "15px" }}
          >
            <div className="pdf-agreement-address-line">
              <strong>Street Address:</strong> {data?.present_map_address || ""}
            </div>
            <div className="pdf-agreement-phone-line">
              <strong>Phone#:</strong> {data?.mobile_no || ""}
            </div>
            <div className="pdf-agreement-email-line">
              <strong>Email:</strong> {data?.email || ""}
            </div>
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginTop: "20px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Agree for Tolls and Ticket
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  Yes, Agree for Tolls and Ticket
                </td>
              </tr>
            </tbody>
          </table>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginTop: "25px",
            }}
          >
            DISCLOSER AUTHORIZATION FORM
          </h2>
        </div>

        {/* ==================== PAGE 6 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-6"
          id="pdf-agreement-part-6"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <div
            className="pdf-agreement-car-info-disclosure"
            style={{ marginBottom: "15px" }}
          >
            <strong>CAR INFO:</strong> ( {data?.car_data?.car_tagline || ""} )
            {data?.car_data?.car_name || ""} / VIN#:
            {data?.car_data?.vin || ""} / Make:
            {data?.car_data?.make_year || ""} / Model:
            {data?.car_data?.model || ""}
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px" }}
          >
            I {data?.first_name || ""} {data?.last_name || ""}, use the
            above-mentioned vehicle for Rideshare / other platform.
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            I authorize the owner of the Vehicle to obtain information /
            incident report from my Rideshare / other platform such as, but not
            limited to {data?.Approved_readr_work || ""}
          </div>

          <div
            className="pdf-agreement-contact-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>My Phone Number is</strong> {data?.mobile_no || ""}
          </div>
          <div
            className="pdf-agreement-contact-info"
            style={{ marginBottom: "15px" }}
          >
            <strong>Email:</strong> {data?.email || ""}
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Agree for the Discloser?
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  Yes, Agree for Discloser
                </td>
              </tr>
            </tbody>
          </table>

          <h3
            className="pdf-agreement-subsection-title"
            style={{
              fontSize: "12pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            DO's
          </h3>

          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            More than 1/4 tank gas should be always maintained. If you run out
            of gas, $90 will be charged for the Roadside Assistant.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Any new warning sign or driving issues should be reported
            immediately and do not keep driving.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Coming for Bi-weekly Servicing is mandatory. If you MISS your
            bi-weekly car service, you will be responsible for any damage to the
            engine or other parts.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Parking and car safety is renter's responsibility. If you need
            parking permit or tags, please make sure you have it on the car.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            If your car is towed away for any reason, report us immediately. You
            will have to pay charges for the towing / impound, etc.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Check Oil and Coolant level once a week.
          </div>

          {/* Duplicate DO's section as shown in PDF */}
          <h3
            className="pdf-agreement-subsection-title"
            style={{
              fontSize: "12pt",
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            DO's
          </h3>

          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            More than 1/4 tank gas should be always maintained. If you run out
            of gas, $90 will be charged for the Roadside Assistant.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Any new warning sign or driving issues should be reported
            immediately and do not keep driving.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Coming for Bi-weekly Servicing is mandatory. If you MISS your
            bi-weekly car service, you will be responsible for any damage to the
            engine or other parts.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Parking and car safety is renter's responsibility. If you need
            parking permit or tags, please make sure you have it on the car.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            If your car is towed away for any reason, report us immediately. You
            will have to pay charges for the towing
          </div>
        </div>

        {/* ==================== PAGE 7 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-7"
          id="pdf-agreement-part-7"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            / impound, etc.
          </div>
          <div
            className="pdf-agreement-dos-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "15px",
            }}
          >
            Check Oil and Coolant level once a week.
          </div>

          <h3
            className="pdf-agreement-subsection-title"
            style={{
              fontSize: "12pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            DONT's
          </h3>

          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Cannot leave car running while step out of car while Pickup / drop
            offs, filling gas, etc.
          </div>
          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Do not leave running Blinkers / fan / radio etc. when you leave your
            car as it will drain the battery. If you drain the Battery, $90 will
            be charged for the Roadside Assistant.
          </div>
          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Cannot leave car keys in the car any time. Should be always in
            renter's possession. $90 will be charged for the Roadside Assistant.
          </div>
          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Cannot allow any other person / family / friend to operate the
            rented vehicle.
          </div>
          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Do not bring any family members/ kids/ elderly person with you when
            you come for car service due to safety reasons.
          </div>
          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "5px",
            }}
          >
            Cannot release car to any towing company / repair shop other than
            authorized by company. You will be responsible to the cost.
          </div>
          <div
            className="pdf-agreement-donts-item pdf-agreement-highlight"
            style={{
              backgroundColor: "#E8F4FD",
              padding: "15px",
              marginBottom: "15px",
            }}
          >
            Cannot keep driving and damage tire and wheel of the car if there is
            nail or low air. In the event of damage renter is responsible for
            the cost of repair. $90 will be charged for the Roadside Assistant.
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "40%" }}
                >
                  Agree for Do's & Dont's?
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  Yes, Agree for Do's & Dont's
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  Where will you Park car?
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    paddingTop: "10px",
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.parking_location || "Street Parking"}
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  Recommended AAA Road Side Assistant.
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    paddingTop: "10px",
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.aaa_road_side_assistance || "May decide later"}. (Your
                  will be responsible to any Roadside Assistant : need for Jump
                  / putting Donut / locked out etc. It may be available through
                  Uber/Lyft or otherwise)
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* ==================== PAGE 8 ==================== */}
        <div
          className="pdf-agreement-page pdf-agreement-part-8"
          id="pdf-agreement-part-8"
          style={{
            width: "210mm",
            height: "297mm",
            maxHeight: "297mm",
            padding: "15mm 20mm",
            backgroundColor: "#FFFFFF",
            fontFamily: "Arial, sans-serif",
            fontSize: "10.5pt",
            lineHeight: "1.3",
            color: "#000000",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Agreement of Terms and Condition for Car Insurance
          </h2>

          <div
            className="pdf-agreement-insurance-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>Company / Car Owner:</strong> {data?.company_name || ""}
          </div>
          <div
            className="pdf-agreement-insurance-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>Driver:</strong> {data?.first_name || ""}{" "}
            {data?.last_name || ""}
          </div>
          <div
            className="pdf-agreement-insurance-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>DL #:</strong> {data?.driving_licence || ""}
          </div>
          <div
            className="pdf-agreement-insurance-info"
            style={{ marginBottom: "10px" }}
          >
            <strong>Insurance Policy#:</strong>
          </div>
          <div
            className="pdf-agreement-insurance-info"
            style={{ marginBottom: "15px" }}
          >
            <strong>Car:</strong> ( {data?.car_data?.car_tagline || ""} )
            {data?.car_data?.car_name || ""} / VIN#:
            {data?.car_data?.vin || ""} / Make:
            {data?.car_data?.make_year || ""} / Model:
            {data?.car_data?.model || ""}
          </div>

          <div
            className="pdf-agreement-insurance-dates"
            style={{ marginBottom: "15px" }}
          >
            <strong>Start date</strong>{" "}
            {formatDateStringdot(data?.from_date || "")} -{" "}
            <strong>End date</strong>
          </div>

          <div
            className="pdf-agreement-text-block"
            style={{ marginBottom: "15px", textAlign: "justify" }}
          >
            The above company/owner will be lien Holder / Lessor/ additional
            interest and loss payee for the above policy. Any Refund at the time
            of cancellation or payments will be directly sent to the company /
            Owner.
          </div>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "50%" }}
                >
                  Agreement for Terms and Condition for Car Insurance
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  Accept
                </td>
              </tr>
            </tbody>
          </table>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Card Authorization
          </h2>

          <ul
            className="pdf-agreement-list pdf-agreement-card-auth-list"
            style={{ marginLeft: "20px", marginBottom: "15px" }}
          >
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "10px" }}
            >
              I hereby affirm that I am the owner of the credit / debit card
              used to make payments and that my name is listed on the front of
              the credit card.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "10px" }}
            >
              Any payment made for the car rental and other charges such as
              Tickets, Tolls, Unpaid rent, Repossession, Impounding, Towing,
              Damage, Cleaning etc ARE NON-REFUNDABLE.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "10px" }}
            >
              I will not use the card which is not on my name for the rental
              payment.
            </li>
            <li
              className="pdf-agreement-list-item"
              style={{ marginBottom: "10px" }}
            >
              I will be personally responsible for all the dues and payments
              made.
            </li>
          </ul>

          <h2
            className="pdf-agreement-section-title"
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Car Rental Payment
          </h2>

          <table
            className="pdf-agreement-info-table"
            style={{ width: "100%", marginBottom: "15px" }}
          >
            <tbody>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{ fontWeight: "bold", width: "50%" }}
                >
                  Payment required before pickup
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  $
                  {parseInt(data?.per_day_rent || 0) +
                    parseInt(data?.per_day_surcharges || 0)}{" "}
                  for {data?.model || ""} ({data?.per_day_rent || ""} / Day +{" "}
                  {data?.per_day_surcharges || ""} Deposit)
                </td>
              </tr>
              <tr>
                <td
                  className="pdf-agreement-label"
                  style={{
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  How you want to pay?
                </td>
                <td
                  className="pdf-agreement-value pdf-agreement-highlight"
                  style={{
                    paddingTop: "10px",
                    backgroundColor: "#E8F4FD",
                    padding: "5px 10px",
                  }}
                >
                  {data?.payment_method || ""}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

export default ViewAgreeMentForm;
